import { render, staticRenderFns } from "./sub_do.vue?vue&type=template&id=5fa3770b&scoped=true"
import script from "./sub_do.vue?vue&type=script&lang=js"
export * from "./sub_do.vue?vue&type=script&lang=js"
import style0 from "./sub_do.vue?vue&type=style&index=0&id=5fa3770b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa3770b",
  null
  
)

export default component.exports